export default __webpack_public_path__ + "static/media/3 dots.dcbb6c7d.svg";